import { useEffect, useState, useRef } from "react";
import { Typography, Space, Breadcrumb, Table, Tag} from "antd";
import { Link, useLocation, useParams, Navigate } from "react-router-dom";
import { LinkedinOutlined, MediumOutlined} from '@ant-design/icons';
import {FooterSmal, Container, MenuSmall} from '../auxiliary/auxiliary';
import BugbountyCard from './BugbountyCard';
import BugbountyTable from './BugbountyTable';
import { Helmet } from "react-helmet-async";

function BugbountyEntryPoint() {
  
  const { id } = useParams();
  const num = parseInt(id, 10);
  const didSetMenu = useRef(false);
 

  const menuItems = [
    { key: '1', label: <Link to="#">Labs</Link> },
    { key: '2', label: <Link to="#">Tools</Link> },
    { key: '3', label: <Link to="/bugbounty/">Bug bounty</Link> }
  ];

  const menuArr = [
    { title: <Link to="/">Home</Link> },
    { title: "Bug bounty", menu: { items: menuItems } }
  ];

  const [menuItem, setMenuItem] = useState(menuArr);




    const [data, setData] = useState([]);

    // 🔹 Состояние для динамического SEO
    const [seo, setSeo] = useState({
      title: "HackerHub — Bug Bounty Platform",
      description: "Independent bug bounty platform. Find vulnerabilities, participate in private programs, and earn rewards."
    });

    // 1. Загрузка данных (без ref-блокировщиков, просто со стандартным флагом)
    useEffect(() => {
      let isMounted = true;

      async function fetchData() {
        try {
          const response = await fetch("/api/bugbounty/programs.json"); 
          if (!response.ok) throw new Error("Network response was not ok");
          const json = await response.json();
          if (isMounted) setData(json);
        } catch (err) {
          console.error(err);
        }
      }
      
      fetchData();
      return () => { isMounted = false; };
    }, []); // Вызовется строго 1 раз при монтировании компонента



    // 2. Логика динамического изменения SEO тегов
    useEffect(() => {
      // Важно: проверяем, что id существует И данные из JSON уже прилетели
      if (id && !isNaN(num) && num >= 0 && data.length > 0) {
        
        // Приводим обе стороны к строке для надежности сравнения ("1" === "1")
        const currentProgram = data.find(item => String(item.key) === String(id));

        if (currentProgram) {
          setSeo({
            title: `${currentProgram.name} Bug Bounty | HackerHub`,
            description: currentProgram.short
          });
        }
      } else {
        // Дефолтные теги для главной страницы баг-баунти
        setSeo({
          title: "Bug Bounty Programs Directory | HackerHub",
          description: "Explore the list of bug bounty programs. Find your next target on HackerHub."
        });
      }
    }, [id, data, num]); // Следим за изменением id и за моментом, когда data наконец загрузится



  // 🔹 сбрасываем меню при отсутствии/некорректности id
  useEffect(() => {
    if (!id || isNaN(num) || num < 0) {
      setMenuItem(menuArr);
    }
  }, [id]);

  
  return (    
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#fff",
      }}
    >

      {/* 🔹 Вставляем динамические теги в <head> */}
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        {/* Можно также динамически дополнить Open Graph теги */}
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
      </Helmet>



      {/* Основное содержимое страницы */}
      <div style={{ flex: 1, overflowY: "auto" }}>
      <MenuSmall/>
      <Container>
        <Breadcrumb style={{margin:"30px 0"}} items={menuItem}/>
          { !id || isNaN(num) || num < 0 ? (
          <BugbountyTable 
            data={data}
          />
          ) : (
            <BugbountyCard programId={num} data={data} setMenuItem={setMenuItem} />
          )}

      </Container>
    </div>

      {/* Минималистичный подвал */}
      <FooterSmal
        style={{
          textAlign: "center",
          fontSize: "12px",
          color: "#999",
          padding: "10px 0",
          borderTop: "1px solid #eee",
        }}
      >
        © {new Date().getFullYear()} Bug Bounty Directory
      </FooterSmal>
    </div>
  );
}

export default BugbountyEntryPoint;